import getIsMobile from 'ismobilejs';

const isCypressMobile = window.Cypress && window.innerWidth < 650;

export const isMobile = getIsMobile(window.navigator).any || isCypressMobile;
